import Vue from "vue";
import Router from "vue-router";

const editor = () => import("./views/home/Home.vue");
Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: editor,
      meta: {
        keepAlive: true,
      },
    },
  ],
});
